import { Link } from "react-router-dom";
import { topics, stats } from "@/mocks/site";

export default function TopicSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="mb-6 md:mb-8">
        <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">
          推荐专题 / 合集
        </h2>
        <p className="mt-2 text-sm md:text-base text-foreground-500">
          为你整理的主题片单，一次看个够
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-12">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={topic.href}
            className="group relative rounded-lg overflow-hidden h-52 md:h-60 cursor-pointer"
          >
            <img
              src={topic.image}
              alt={`${topic.title} 专题封面`}
              title={`${topic.title} - 51动漫`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5">
              <span className="inline-block px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[11px] font-semibold mb-2">
                {topic.count} 部作品
              </span>
              <h3 className="font-heading font-bold text-lg text-background-50">{topic.title}</h3>
              <p className="mt-1 text-xs text-background-100/80 line-clamp-2">{topic.desc}</p>
            </div>
          </Link>
        ))}
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 p-6 md:p-8 rounded-lg bg-primary-950">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center">
            <div className="font-heading font-extrabold text-2xl md:text-4xl text-primary-400">
              {stat.value}
            </div>
            <div className="mt-1.5 text-xs md:text-sm text-background-100/80">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}